<div class="sp-dialog__max-width-m sp-dialog__min-width">
  <div class="sp-width__full sp-row__end">
    <button
      (click)="onCloseClick()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent">
      <mat-icon> clear </mat-icon>
    </button>
  </div>

  <div class="sp-padding__x2">
    <h3>
      {{ 'BUYERS.DELETE_CTA' | translate }}
    </h3>

    <div *ngIf="!is_sources_list_running && payment_sources?.length">
      <mat-radio-group
        [(ngModel)]="payment_source"
        class="sp-margin__vert-x2 sp-column">
        <mat-radio-button
          *ngFor="let ps of payment_sources"
          [value]="ps">
          <span class="sp-color__primary">
            **** {{ ps.stripe_card?.last4 || '-' }} - {{ ps.stripe_card?.exp_month || '-' }}/{{
              ps.stripe_card?.exp_year
            }}</span
          >
        </mat-radio-button>
      </mat-radio-group>

      <app-shared-button
        class="sp-width__full"
        [button_class]="'sp-button__main'"
        [spinner_class]="'sp-spinner__main'"
        [is_disabled]="!payment_source"
        [is_spinner_visible]="is_delete_running"
        [cta]="'GENERAL.CONFIRM_CTA'"
        (button_click)="onConfirmClick()"></app-shared-button>
    </div>

    <div
      *ngIf="is_sources_list_running"
      class="sp-column__center sp-width__full sp-padding__x2">
      <mat-spinner
        color="accent"
        diameter="40"></mat-spinner>
      <p class="sp-color__accent sp-text__center sp-margin__top">Loading...</p>
    </div>

    <div *ngIf="!is_sources_list_running && !payment_sources?.length">
      <p class="sp-color__primary">{{ 'BUYERS.EMPTY_LABEL' | translate }}</p>
    </div>
  </div>
</div>
